import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";
import { LeaderboardMetric } from "../../../interfaces/views";
import { getServicesManager } from "../../../services";

export interface LeaderboardMetricsState {
  value: LeaderboardMetric[] | null;
  isEditingModalOpen: boolean;
  editingMetric: LeaderboardMetric | null;
}

const leaderboardMetricsInitialState: LeaderboardMetricsState = {
  value: null,
  isEditingModalOpen: false,
  editingMetric: null,
};

export const leaderboardMetricsSlice = createSlice({
  name: 'leaderboardMetrics',
  initialState: leaderboardMetricsInitialState,
  reducers: {
    updateLeaderboardMetrics: (state, action: PayloadAction<LeaderboardMetric[]>) => {
      state.value = action.payload;
    },
    openEditingModal: (state, action: PayloadAction<LeaderboardMetric | null>) => {
      state.isEditingModalOpen = true;
      state.editingMetric = action.payload;
    },
    closeEditingModal: (state) => {
      state.isEditingModalOpen = false;
      state.editingMetric = null;
    },
  }
});

export const { updateLeaderboardMetrics, openEditingModal, closeEditingModal } = leaderboardMetricsSlice.actions;

export function reloadLeaderboardMetrics(dispatch: Dispatch): Promise<LeaderboardMetric[] | null> {
  const result = getServicesManager().getLeaderboardMetrics();
  result.then(v => {
    if (v !== null) {
      dispatch(leaderboardMetricsSlice.actions.updateLeaderboardMetrics(v));
    }
  });
  return result;
}
